import { Route } from '@angular/router';
import { IndexPage } from 'app/modules/well-healthiness/pages/index/index.page';
import { DashboardPage } from 'app/modules/well-healthiness//pages/dashboard/dashboard.page';
import { FieldSummaryPage } from 'app/modules/well-healthiness//pages/field-summary/field-summary.page';
import { StringSummaryPage } from 'app/modules/well-healthiness/pages/string-summary/string-summary.page';

export const whDashboardRoutes: Route[] = [
    {
        path: 'well-healthiness',
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'dashboard',
            },
            {
                path: 'dashboard',
                component: DashboardPage,
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'field',
                    },
                    {
                        path: 'field',
                        component: FieldSummaryPage,
                    },
                    {
                        path: 'string',
                        component: StringSummaryPage,
                    }
                ]
            },
        ],
    },
];

export const whDataManagementRoutes: Route[] = [
    {
        path: 'well-healthiness',
        component: IndexPage,
    },
];

export const whConfigurationRoutes: Route[] = [
    {
        path: 'well-healthiness',
        children: [],
    },
];
